module.exports = __webpack_public_path__ + "static/media/about-2-bg-cut.4d28a1cf.png";